import { Check, Phone } from "lucide-react";
import { Container, PillButton, SmartImg } from "@/components/common/ui";
import { EnquiryForm } from "@/components/forms/EnquiryForm";
import { IMAGES, SITE, TEAM_PHOTO } from "@/lib/site";

const PCS_POINTS = [
  "Our Broker in charge is a 30-year retired Navy Senior Chief",
  "Fundamental knowledge of the V.A. loan program, Virginia Housing Grant & FHA 203K",
  "We help you make the most out of your house hunting leave",
  "Property management and rental of your current home",
];

export const SellerBand = () => (
  <section className="pb-4" data-testid="seller-band">
    <Container>
      <div className="relative overflow-hidden rounded-md bg-neutral-900">
        <img src={IMAGES.pool} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent" />
        <div className="relative max-w-xl px-7 py-14 sm:px-12 sm:py-20">
          <p className="eyebrow !text-brass">Seller's Advantage Discount Listing Program</p>
          <h2 className="mt-4 font-display text-4xl font-normal leading-tight text-white sm:text-5xl">Never pay 6% again.</h2>
          <p className="mt-4 text-[17px] text-white/85">
            List and sell your property for 4.75% total commission. Save thousands on the sale of your home, with a tradition of bringing 99% of ask to our seller clients.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <PillButton to="/sellers#savings" tone="light" testId="seller-band-calc">Calculate your savings</PillButton>
            <PillButton to="/sellers#market-analysis" tone="ghostLight" arrow={false} testId="seller-band-fma">Free market analysis</PillButton>
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export const TeamQuote = () => (
  <section className="py-16 sm:py-24" data-testid="team-quote">
    <Container className="grid items-center gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
      <div className="relative">
        <SmartImg src={TEAM_PHOTO} fallbackSrc={IMAGES.militaryFamily} alt="The Rob Resh Team" className="aspect-[4/3] w-full rounded-md object-cover" testId="team-photo" />
        <div className="absolute -bottom-6 right-6 rounded-md bg-ink px-5 py-4 text-white shadow-xl">
          <p className="font-display text-3xl">21 years</p>
          <p className="text-[13px] text-white/70">combined in Hampton Roads & Richmond</p>
        </div>
      </div>
      <div>
        <p className="eyebrow">The Rob Resh Team</p>
        <blockquote className="mt-4 font-display text-3xl leading-snug text-ink sm:text-[40px] sm:leading-[1.2]">
          “Large enough to provide top customer service, but small enough to genuinely care!”
        </blockquote>
        <p className="mt-6 text-[17px] leading-relaxed text-neutral-600">
          Rob demands that his agents provide the best communication for our clients. Our Broker in charge is a 30-year retired Navy Senior Chief, and Bill keeps our team on course with constant training.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <PillButton to="/about" testId="team-quote-about">Meet the team</PillButton>
          <PillButton href={SITE.phoneMainHref} tone="outline" arrow={false} testId="team-quote-call"><Phone className="h-4 w-4" /> {SITE.phoneMain}</PillButton>
        </div>
      </div>
    </Container>
  </section>
);

export const PcsCta = ({ id = "pcs-form", defaultBaseId, title = "Got orders? Let's talk." }) => (
  <section id={id} className="scroll-mt-20 bg-ink py-20 text-white sm:py-24" data-testid="pcs-cta">
    <Container className="grid gap-12 lg:grid-cols-[1fr_1.05fr] lg:gap-16">
      <div>
        <p className="eyebrow !text-brass">Military relocation</p>
        <h2 className="mt-4 font-display text-4xl font-normal leading-tight sm:text-5xl">{title}</h2>
        <p className="mt-4 max-w-md text-[17px] text-white/75">
          Tell us where you're reporting and when. We'll shortlist homes by distance to your installation and plan your house-hunting days with you.
        </p>
        <ul className="mt-8 space-y-4">
          {PCS_POINTS.map((p) => (
            <li key={p} className="flex gap-3 text-[15px] text-white/90">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-brass text-ink"><Check className="h-3 w-3" /></span>
              {p}
            </li>
          ))}
        </ul>
        <a href={SITE.phoneMainHref} data-testid="pcs-cta-call" className="mt-10 inline-flex items-center gap-2 text-lg text-white underline decoration-brass underline-offset-8 hover:decoration-white">
          <Phone className="h-5 w-5" /> Call {SITE.phoneMain}
        </a>
      </div>
      <div className="rounded-md bg-white p-6 text-ink sm:p-8">
        <p className="text-xl font-medium">Start my PCS plan</p>
        <p className="mb-6 mt-1 text-[14px] text-neutral-500">Takes a minute. A real person replies.</p>
        <EnquiryForm kind="pcs" extras={["direction", "branch", "base", "reportDate"]} submitLabel="Send my PCS details" defaultBaseId={defaultBaseId}
          messagePlaceholder="Family size, must-haves, budget, school needs…" testIdPrefix="pcs" />
      </div>
    </Container>
  </section>
);
